module.exports = __webpack_public_path__ + "img/TickSquare@2x.0d3596d2.png";